import script from "./AutorizationKeypad.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorizationKeypad.vue?vue&type=script&setup=true&lang=js"

import "./AutorizationKeypad.vue?vue&type=style&index=0&id=d29e81c6&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d29e81c6"]])

export default __exports__